export * from "./directives/collapse";
export * from "./collapse.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/collapse/index.js
// module id = 201
// module chunks = 0